/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { cssUtils, propsUtils } from '@ba-ui-toolkit/utils';

const { cssSize } = cssUtils;
const { sanitize } = propsUtils;

export default class VSpacer extends Component {
	static propTypes = {
		size: PropTypes.number,
		className: PropTypes.string,
		style: PropTypes.object,
	};

	static defaultProps = {
		size: 2, // * 8  = 16 pixels
		className: '',
		style: {},
	};

	render() {
		const { className, style, ...others } = this.props;
		const styles = {
			marginTop: cssSize(this.props.size),
			...style,
		};

		return <div {...sanitize(others, VSpacer)} style={styles} className={className} />;
	}
}
